import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';

const initialState = {
    id: '',
    orderId: '',
    order: {
        id: '',
        taffiId: '',
        items: [] as Array<any>,
        deliveryAddress: {},
    },
    isEffect: false,
};
const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        resetCart: (state) => ({ ...initialState }),
        setIsEffect: (state, action) => {
            state.isEffect = action.payload;
        },
        setCartOrder: (state, action) => {
            state.id = action.payload?.id || '';
            state.orderId = action.payload?.orderId || '';
            const order = action.payload?.order;
            const orderUpdate = {
                id: order?.id,
                userId: order?.userId,
                taxPercentage: order?.taxPercentage,
                status: order?.status,
                statusDetail: {
                    status: order?.statusDetail?.status,
                    description: order?.statusDetail?.description,
                    displayStr: order?.statusDetail?.displayStr,
                },
                orderPlacedDate: order?.orderPlacedDate,
                taffiId: order?.taffiId,
                items: get(order, ['items'], []).map((item) => ({
                    id: item?.id,
                    data: item?.data,
                    contextDetail: item?.contextDetail,
                    quantity: item?.quantity,
                    status: item?.status,
                    statusDetail: {
                        status: item?.statusDetail?.status,
                        displayStr: item?.statusDetail?.displayStr,
                        description: item?.statusDetail?.description,
                    },
                    type: item?.type,
                    contextId: item?.contextId,
                    contextType: item?.contextType,
                    contextTaffiId: item?.contextDetail?.contextTaffiId,
                    currency: item?.currency,
                    size: item?.size,
                    color: item?.color,
                    price: item?.price,
                    inStock: item?.inStock,
                    lastAvailabilityCheck: item?.lastAvailabilityCheck,
                })),
            };
            state.order = { ...state.order, ...orderUpdate };
        },
        updateListQuantity: (state, action) => {
            const items = state?.order?.items || [];
            const newItems = action?.payload?.items || [];
            state.order.items = items
                .map((item) => {
                    const existItem = newItems.find(
                        (newItem) =>
                            item?.id === newItem?.id && item?.color === newItem?.color && item?.size === newItem?.size,
                    );
                    return { ...item, quantity: existItem ? existItem?.quantity || 0 : 0 };
                })
                .filter((item) => item.quantity > 0);
        },
        updateOrderItem: (state, action) => {
            let items = state?.order?.items || [];
            const { payload } = action;
            items = items.map((item) => {
                if (item.id === action.payload.id) {
                    return {
                        ...item,
                        ...payload,
                    };
                }
                return item;
            });
            state.order = {
                ...state.order,
                items,
            };
        },
    },
});

export const { setCartOrder, resetCart, updateListQuantity, updateOrderItem, setIsEffect } = cartSlice.actions;
const cartReducer = cartSlice.reducer;
export default cartReducer;
